<template>
  <div class="productSwiper">
    <swiper :options="swiperOption" ref="productSwiper" id="productSwiper">
        <swiper-slide v-for="item in productimg" :key="item.ID">
          <img :src="'http://donghao.chinadonghao.com/upload/'+item.BIGURL" alt="">
        </swiper-slide>
    </swiper>
  </div>
</template>

<script>
// @ is an alias to /src
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { mapState } from 'vuex'
import { getPicUrl } from '@/util/lang.js'

export default {
  name: 'productSwiper',
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption:{
        notNextTick: true,
        loop: true,
        init: false,
        autoplay: {
          disableOnInteraction: false,
          delay: 5000,//5秒切换一次
        }
      },
      productimg: []
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    })
  },
  watch: {
    lang: 'fetchDate'
  },
  mounted () {
    this.fetchDate(this.lang)
  },
  methods: {
    fetchDate (val) {
      if (val) {
        const url = getPicUrl(this.lang, '首页产品轮播', '10')
        this.$$axios.get(url).then(res => {
          this.productimg = res.data
          this.$nextTick(()=>{
            this.$refs.productSwiper.swiper.init()
          })
        })
      }
    }
  }
}
</script>

<style scoped>
.productSwiper img{
  max-width: 100%;
  margin: 0 auto;
}
</style>

